module.exports = __webpack_public_path__ + "static/media/portrait.da60ae0c.svg";